import React from 'react'
// eslint-disable-next-line react/prop-types
const CloseSVG =({className, onClick}) =>



<svg className={className} onClick={onClick}  width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <title>57DC583C-FA54-4AAF-A063-B394A7DAFF99</title>
    <g id="Gestão-de-Acessos-Novo" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="03.1---Gestão-de-acessos-" transform="translate(-1259.000000, -30.000000)" fill="#41A017" fillRule="nonzero">
            <g id="Group-6" transform="translate(913.000000, 0.000000)">
                <g id="Cross/2" transform="translate(346.000000, 30.000000)">
                    <path d="M8.63201819,10.0103823 C5.74928118,7.12701676 2.87083459,4.24794258 0,1.37648207 C0.458588941,0.917723928 0.907489871,0.468655911 1.358882,0.0170961468 C4.22681019,2.88571883 7.10532598,5.76493144 9.98058938,8.64082172 C12.8645028,5.75627955 15.744541,2.8755442 18.6194584,0 C19.0669753,0.447545284 19.500929,0.88159361 19.9350211,1.31564194 L11.2981589,9.9543872 C14.2077456,12.864539 17.1080594,15.7655544 20,18.6580563 C19.5492307,19.1089239 19.1021981,19.5561231 18.6583488,20 C15.7714598,17.1124816 12.8699004,14.2102895 9.96460416,11.3043599 C7.07093354,14.1986614 4.19110295,17.0791891 1.31729275,19.9536258 C0.876972635,19.5132097 0.443364923,19.0795075 0.00408280482,18.6401988 C2.87540179,15.7682538 5.75488639,12.8881414 8.63201819,10.0103823" id="Fill-1"></path>
                </g>
            </g>
        </g>
    </g>
</svg>

export default CloseSVG
